import Navigation, { INavigationItem } from './Navigation';

import DevicesIcon from '@icons/devices.svg?react';

export default function MenuNavigation() {
  const menuItems: INavigationItem[] = [
    { icon: <DevicesIcon />, label: 'browse', url: '/models' },
    { icon: <DevicesIcon />, label: 'upload', url: '/upload' }
  ];

  return <Navigation items={menuItems} />;
}
